import React, {Component} from 'react'
import $ from 'jquery'
import {Link} from 'react-router-dom';
import {BodyContext} from '~/context/BodyContext.js'
import {Watch, Actions, Api} from '~/scripts'
import C from '~/components';
import Swal from 'sweetalert2';

import Slider, {Range} from 'rc-slider';
import 'rc-slider/assets/index.css';

export default class Market extends Component {
    static contextType = BodyContext;

    constructor() {
        super()
        this.state = {
            volume: [],
            sliderValues: [2, 1000],
            risRanging: false,
            priceValues: [2, 1000],
            interf: {
                lengthOfShowingPunks: 50,
                filterings_types: [],
                filterings_attributes: [],
                filterings_sort: [],
                isLoading: false,
                isSortByRank: false,
                isOnlyHasBid: false,
                isOnlyOffered: false,
            },
            storage: {
                punks: [],
                punksToShow: []
            }
        }
    }

    componentWillMount() {
        const [CT] = this.context;
        CT.set_classing({
            route: 'market',
        });
    }

    componentDidMount() {
        Watch.init(this);
        this._loadData();
    }

    async _loadData() {
        const [CT] = this.context;
        this._sst('interf', {isLoading: true})
        const forSalePunks = await Api.get('/all')
        let currentPunkIndex = null
        let punks = [
            {
                ...CT.storage.PUNKS[0],
                owner: 0,
                extra: {
                    punkBids: {},
                    punksOfferedForSale: {},
                }
            }
        ]
        let kk = 0;
        await CT.storage.PUNKS.map(async punk => {
            forSalePunks.map(forSalePunk => {
                currentPunkIndex = forSalePunk.token_id

                currentPunkIndex == punk.idx && punks.push({
                    ...punk,
                    owner: forSalePunk.data.owner ?? 0,
                    extra: {
                        punkBids: forSalePunk.data.punkBids ?? {},
                        punksOfferedForSale: forSalePunk.data.punksOfferedForSale ?? {},
                    }
                })
            })
        })
        // console.log('------------------==----------------', punks);

        this._sst('storage', {punks: punks, punksToShow: punks})
        this._sst('interf', {isLoading: false})
        Watch.punksScrollLoad(this);
    }

    _sst(main, obj) {
        this.setState({
            [main]: {
                ...this.state[main],
                ...obj
            }
        })
    }

    showFilterBox() {
        const [CT] = this.context;
        let as = CT.storage.FILTERS.attributes
        console.log(as)
        Swal.fire({
            title: '<div class="swal--head"> Filter </div>',
            icon: null,
            showCloseButton: true,
            html:
                `
                    <div class="swal--content">
                        <div class="filter_section">
                            ${Object.keys(CT.storage.FILTERS).map(filterGroup => {
                    return (`
                            <div class="title">
                                <span>
                                    ${filterGroup}
                                </span>
                            </div>
                            <div class="checklist">
                                ${Object.keys(CT.storage.FILTERS[filterGroup]).map(filter => {
                        return (`
                                <label class="CheckBox">${filter} ${CT.storage.FILTERS[filterGroup][filter].count ? '(' + CT.storage.FILTERS[filterGroup][filter].count + ")" : ''}
                                    <input type="checkbox" ${this.state.interf[`filterings_${filterGroup}`].includes(filter) ? 'checked' : ''} data-filter="${filterGroup}" data-value="${filter}" />
                                    <span class="checkmark"></span>
                                </label>
                        `)
                    }).join('')}
                            </div>
                    `)
                }).join('')}
                        </div>
                    </div>  
                `,
            focusConfirm: false,
            didOpen: () => {
                const _ = this;
                $('.swal .filter_section .checklist input').on('change', function () {
                    _.filterPunks(this.checked ? 'ADD' : 'DEL', $(this).attr('data-filter'), $(this).attr('data-value'))
                })
            },
            customClass: {
                container: 'swal',
                popup: 'swal-box -big',
                title: 'swal--title',
                closeButton: 'swal-closebtn',
                denyButton: '',
                confirmButton: 'Btn -force',
                cancelButton: '',
            }
        }).then((result) => {
            if (result.isConfirmed) {
            }
        })
    }

    searchPunks(value) {
        const punks = this.state.storage.punks
        const finded = []
        punks.find(x => x.idx == value) && finded.push(punks.find(x => x.idx == value))
        setTimeout(() => {
            this.setState({
                storage: {
                    ...this.state.storage,
                    punksToShow: value ? finded : punks
                }
            })
        }, 1000);
    }

    filterPunks(mode, section, filter) {
        // let punks = mode === 'ADD' ? this.state.storage.punksToShow : this.state.storage.punks
        let punks = this.state.storage.punks
        let {filterings_types, filterings_attributes, filterings_sort} = this.state.interf
        let filteredPunks = []
        if (section === 'attributes') {
            let _index = filterings_attributes.indexOf(filter)
            if (_index == -1 && mode === 'ADD') {
                filterings_attributes.push(filter);
            } else if (_index > -1 && mode === 'DEL') {
                filterings_attributes.splice(_index, 1);
            }
        } else if (section === 'types') {
            let _index = filterings_types.indexOf(filter)
            if (_index == -1 && mode === 'ADD') {
                filterings_types.push(filter);
            } else if (_index > -1 && mode === 'DEL') {
                filterings_types.splice(_index, 1);
            }
        }
        // else if (section === 'sort') {
        //
        // }


        if (filterings_attributes.length > 0)
            punks = punks.filter(punk => {
                let exist = false;
                filterings_attributes.map(_fattr => {
                    punk['attributes'].map(_attr => {
                        if (_fattr == _attr)
                            exist = true;
                    })
                });
                return exist;
            })

        if (filterings_types.length > 0)
            punks = punks.filter(punk => {
                let exist = false;

                filterings_types.map(_ftype => {
                    if (_ftype == punk['type'])
                        exist = true;
                });

                return exist;
            })

        // filterings_attributes.map(filtering => {
        //     fa_punk = fa_punk.filter(punk => punk['attributes'].includes(filtering));
        // });


        // let ft_punk = fa_punk;
        // filterings_types.map(filtering => {
        //     ft_punk = ft_punk.filter(punk => punk['type'].includes(filtering));
        // });


        // filterings_sort = []
        // mode === 'ADD' ? filterings_sort.push(filter) : filterings_sort.pop(filter)
        // // localPunks = localPunks.filter(punk => punk['type'] === filterings_sort[0]);
        // filteredPunks = localPunks

        // filteredPunks = ft_punk;

        this._sst('interf', {filterings_types})
        this._sst('interf', {filterings_attributes})
        this._sst('interf', {filterings_sort})
        this._sst('storage', {punksToShow: punks})
    }

    async filterSortByRanks(e) {
        this._sst('interf', {isLoading: true})
        let punks = this.state.interf.isOnlyHasBid ? this.state.storage.punksToShow : this.state.storage.punks
        const [CT] = this.context;
        let rankedPunks = CT.storage.PUNKS_SORTED_BY_RANK
        let punksToShow = []

        await this._sst('interf', {filterings_attributes: []})

        if (e.checked) {
            rankedPunks.map(punk => {
                punks.map(myPunk => {
                    punk.idx === myPunk.idx && punksToShow.push(myPunk)
                })
            })
            await this._sst('storage', {punksToShow: punksToShow})
            this._sst('interf', {isLoading: false})
            this._sst('interf', {isSortByRank: true})
        } else {
            await this._sst('storage', {punksToShow: punks})
            this._sst('interf', {isLoading: false})
            this._sst('interf', {isSortByRank: false})
        }
    }

    async filterOnlyHasBid(e) {
        const state = this.state
        this._sst('interf', {isLoading: true})
        const [CT] = this.context;
        const punks = this.state.interf.isSortByRank ? this.state.storage.punksToShow : this.state.storage.punks
        let punksToShow = []

        await this._sst('interf', {filterings_attributes: []})

        if (e.checked) {
            await punks.map(async punk => {
                if (punk.extra.punkBids[0]) {
                    if (state.priceValues[1] < 1000) {
                        if (window.web3Global.utils.fromWei(punk.extra.punkBids.value) >= state.priceValues[0]
                            && window.web3Global.utils.fromWei(punk.extra.punkBids.value) <= state.priceValues[1])
                            punksToShow.push(punk)
                    } else {
                        if (window.web3Global.utils.fromWei(punk.extra.punkBids.value) >= state.priceValues[0])
                            punksToShow.push(punk)
                    }


                }
            })
            punksToShow.sort(function (a, b) {
                return window.web3Global.utils.fromWei(a.extra.punkBids.value ?? 0)
                    - window.web3Global.utils.fromWei(b.extra.punkBids.value ?? 0)
            });
            await this._sst('storage', {modify_punksToShow: punksToShow})
            this._sst('interf', {isLoading: false})
            this._sst('interf', {isOnlyHasBid: true})
        } else {
            this.filterSortByRanks({checked: false})
            await this._sst('storage', {modify_punksToShow: null})
            await this._sst('storage', {punksToShow: punks})
            this._sst('interf', {isLoading: false})
            this._sst('interf', {isOnlyHasBid: false})
            this._sst('interf', {isOnlyOffered: false})
        }
    }

    async filterOnlyHasOffer(e) {
        const state = this.state
        this._sst('interf', {isLoading: true})
        const [CT] = this.context;
        const punks = this.state.storage.punks
        let punksToShow = []

        await this._sst('interf', {filterings_attributes: []})

        if (e.checked) {
            await punks.map(async punk => {
                if (punk.extra.punksOfferedForSale[0]) {

                    if (state.priceValues[1] < 1000) {
                        if (window.web3Global.utils.fromWei(punk.extra.punksOfferedForSale.minValue) >= state.priceValues[0]
                            && window.web3Global.utils.fromWei(punk.extra.punksOfferedForSale.minValue) <= state.priceValues[1])
                            if (punk.extra.punksOfferedForSale.seller == punk.owner) {
                                punksToShow.push(punk)
                                console.log('this is if', punk);
                            }
                    } else {
                        if (window.web3Global.utils.fromWei(punk.extra.punksOfferedForSale.minValue) >= state.priceValues[0])
                            if (punk.extra.punksOfferedForSale.seller == punk.owner) {
                                punksToShow.push(punk)
                                console.log('this is else', punk);
                            }
                    }


                }
            })
            punksToShow.sort(function (a, b) {
                return window.web3Global.utils.fromWei(a.extra.punksOfferedForSale.minValue ?? 0)
                    - window.web3Global.utils.fromWei(b.extra.punksOfferedForSale.minValue ?? 0)
            });
            await this._sst('storage', {modify_punksToShow: punksToShow})
            this._sst('interf', {isLoading: false})
            this._sst('interf', {isOnlyHasBid: false})
            this._sst('interf', {isOnlyOffered: true})
        } else {
            this.filterSortByRanks({checked: false})
            this.filterOnlyHasBid({checked: false})
            await this._sst('storage', {modify_punksToShow: null})
            await this._sst('storage', {punksToShow: punks})
            this._sst('interf', {isLoading: false})
            this._sst('interf', {isOnlyHasBid: false})
        }
    }

    async searchPunksPrice() {
        const interf = this.state.interf
        if (interf.isOnlyHasBid) {
            const state = this.state
            this._sst('interf', {isLoading: true})
            const punks = this.state.storage.punks
            let punksToShow = []
            await punks.map(async punk => {
                if (punk.extra.punkBids[0]) {
                    console.log(punk);
                    if (state.priceValues[1] < 1000) {
                        if (window.web3Global.utils.fromWei(punk.extra.punkBids.value) >= state.priceValues[0]
                            && window.web3Global.utils.fromWei(punk.extra.punkBids.value) <= state.priceValues[1])
                            // if (punk.extra.punkBids.bidder != punk.owner) {
                            punksToShow.push(punk)
                        // }
                    } else {
                        if (window.web3Global.utils.fromWei(punk.extra.punkBids.value) >= state.priceValues[0])
                            // if (punk.extra.punkBids.bidder != punk.owner) {
                            punksToShow.push(punk)
                        // }
                    }
                }
            })
            punksToShow.sort(function (a, b) {
                return window.web3Global.utils.fromWei(a.extra.punkBids.value ?? 0)
                    - window.web3Global.utils.fromWei(b.extra.punkBids.value ?? 0)
            });

            await this._sst('storage', {modify_punksToShow: punksToShow})
            this._sst('interf', {isLoading: false})
            // this.filterOnlyHasBid(e.checked);
        } else if (interf.isOnlyOffered) {
            const state = this.state
            this._sst('interf', {isLoading: true})
            const punks = this.state.storage.punks
            let punksToShow = []
            await this._sst('interf', {filterings_attributes: []})
            await punks.map(async punk => {
                if (punk.extra.punksOfferedForSale[0]) {
                    // console.log('Offer Price:', punk, state.priceValues[0], state.priceValues[1])
                    if (state.priceValues[1] < 1000) {
                        if (window.web3Global.utils.fromWei(punk.extra.punksOfferedForSale.minValue) >= state.priceValues[0]
                            && window.web3Global.utils.fromWei(punk.extra.punksOfferedForSale.minValue) <= state.priceValues[1]) {
                            if (punk.extra.punksOfferedForSale.seller == punk.owner) {
                                punksToShow.push(punk)
                            }
                        }
                    } else {
                        if (window.web3Global.utils.fromWei(punk.extra.punksOfferedForSale.minValue) >= state.priceValues[0])
                            if (punk.extra.punksOfferedForSale.seller == punk.owner) {
                                punksToShow.push(punk)
                            }
                    }
                }
            })
            punksToShow.sort(function (a, b) {
                return window.web3Global.utils.fromWei(a.extra.punksOfferedForSale.minValue ?? 0)
                    - window.web3Global.utils.fromWei(b.extra.punksOfferedForSale.minValue ?? 0)
            });
            await this._sst('storage', {modify_punksToShow: punksToShow})
            this._sst('interf', {isLoading: false})
        }
    }


    handleChange = sliderValues => {
        const state = this.state
        this.setState({sliderValues});
        state.priceValues[0] = sliderValues[0];
        state.priceValues[1] = sliderValues[1];

        if (!this.risRanging) {
            setTimeout(() => {
                console.log('---------sliderValues-----', state.priceValues)
                this.searchPunksPrice();
                this.risRanging = false;
            }, 1000); // 1 sec delay
        }
        this.risRanging = true;
    };

    render() {
        let {volume} = this.state
        const {sliderValues} = this.state;
        const [CT] = this.context;
        const interf = this.state.interf
        const Punks = this.state.storage.modify_punksToShow || this.state.storage.punksToShow
        return (
            <>
                <div className="explorer">
                    <div className="filtering">
                        <div className="searcher">
                            <div className="InputBox -full">
                                <input type="text" placeholder="Search by punk number..."
                                       onChange={(e) => this.searchPunks(e.target.value)}
                                />
                                <i className="ri-search-2-line"></i>
                            </div>

                            {/*<Range*/}
                            {/*    defaultValue={[20,60]}*/}
                            {/*/>*/}
                            {(interf.isOnlyHasBid || interf.isOnlyOffered) &&
                            <div>
                                Filter Price:

                                {sliderValues[0]} ETC - {sliderValues[1] == 1000 ? '+1000' : sliderValues[1]} ETC
                                <Range
                                    min={2}
                                    max={1000}
                                    onChange={this.handleChange}
                                    defaultValue={sliderValues}
                                    tipFormatter={value => <span className="tooltip">{value}€</span>}
                                />
                            </div>
                            }

                            {volume}
                        </div>
                        <div className="extra">
                            {(!interf.isOnlyHasBid && !interf.isOnlyOffered) &&
                            <div className="fast_filter">
                                <label onClick={(e) => this.filterSortByRanks(e.target)} className="CheckBox">Sort by
                                    Rank
                                    <input type="checkbox" id="CHECK-SORT_BY_RANK"/>
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            }
                            {(!interf.isOnlyOffered) &&
                            <div className="fast_filter">
                                <label onClick={(e) => this.filterOnlyHasBid(e.target)} className="CheckBox">Bids
                                    <input type="checkbox"/>
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            }

                            {(!interf.isOnlyHasBid) &&
                            <div className="fast_filter">
                                <label onClick={(e) => this.filterOnlyHasOffer(e.target)} className="CheckBox">Offered
                                    <input type="checkbox"/>
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            }

                            <div className="Actions">
                                <a className="Btn -simple" onClick={() => this.showFilterBox()}>
                                    <i className="ri-equalizer-line"></i>
                                    <span>
                                        Filter
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="body">
                        {interf.isLoading
                            ?
                            <C.Loading/>
                            :
                            (Punks.length
                                ?
                                <C.Punker fixitems light connect
                                          punksData={Punks.slice(0, this.state.interf.lengthOfShowingPunks)}
                                          containerOptions={{wrap: true}}/>
                                :
                                'There is no any Punk for Sale')
                        }
                    </div>
                </div>
            </>
        )
    }
}